import React from 'react';
import { Button, Card, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Title, Text } = Typography;

interface LocationState {
  echoName: string;
  recipientCount: number;
}

const EchoSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  const { echoName = 'Echo', recipientCount = 0 } = state || {};

  return (
    <div className="p-6 max-w-[600px] mx-auto mt-12">
      <Card className="shadow-lg rounded-lg border-gray-100 text-center py-8">
        <CheckCircleFilled className="text-green-500 text-6xl mb-6" />
        
        <Title level={3} className="text-gray-800 mb-2">
          Echo Created Successfully!
        </Title>
        
        <Text className="text-gray-600 block mb-8">
          "{echoName}" has been created and invitations have been sent to {recipientCount} recipient{recipientCount !== 1 ? 's' : ''}.
        </Text>

        <div className="space-y-4">
          <Button
            type="primary"
            size="large"
            className="bg-cyan-600 hover:bg-cyan-500 w-full max-w-sm !rounded-lg"
            onClick={() => navigate('/new-echo')}
          >
            Create Another Echo
          </Button>
          
          <Button
            size="large"
            className="w-full max-w-sm !rounded-lg"
            onClick={() => navigate('/previous-echos')}
          >
            View Previous Echos
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default EchoSuccess; 